// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1e1m3","label":"styles_label__2Yb1i"};